import React , {useEffect ,Fragment} from "react";
import * as s from './CreateFolder.style';
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../../../components/shared/inputs/FormikControl";
import Spinner from '../../../components/shared/spinner/Spinner';
// images
import logo from "../../../assets/images/logo.png";

import * as actions from "../../../store/actions/index";
import {  useSelector, useDispatch } from "react-redux";
import { useParams, useHistory , useLocation } from "react-router-dom";

const CreateFolder = () => {
    
      let dispatch = useDispatch();
      const history = useHistory();

    const initialValues = {
        folderName: ""
      };

      const validationSchema = Yup.object({
        folderName: Yup.string().required("Required")
      });
      

      const onSubmit = (values) => {
        console.log("Form data", values);
        dispatch(actions.createFolders(values , () => history.goBack()))
        
      };


      let folderLoading = useSelector ( (state) => state.userFolders.loading)
      
    




    return(
    <s.ScreenContainer>
        <s.Container>
            {folderLoading === false || folderLoading === null ? (
            <Fragment>
<s.LogoContainer>
          <s.LogoImage src={logo} />
          
        </s.LogoContainer>

        <s.FormContainer>
          
          <Formik
            initialValues={initialValues}
            // validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {(formik) => {
              return (
               
                
                <Form>
                  <s.H1>Create new Folder</s.H1>
                  <s.InputContainer>
                    <FormikControl
                     
                      control="input"
                      // control='chakraInput'
                      type="text"
                      name="folderName"
                      placeholder="FOLDER NAME"
                    />
                    
                  </s.InputContainer>
                  <s.Div>
                    <s.CreateBtn type="submit" disabled={!formik.isValid}>
                      Create
                    </s.CreateBtn>
                  </s.Div>
                </Form>
              );
            }}
          </Formik>
        </s.FormContainer>

            </Fragment> 
             )  :  (
                <s.SpinnerContainer>
                  <Spinner />
               </s.SpinnerContainer>
      )};
                    </s.Container>
    </s.ScreenContainer>
    )
    
};

export default CreateFolder;